<template>
  <b-card>
    <b-card-header>
      <b-card-title>ایجاد درخواست</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="permissions">
                موضوع درخواست
              </label>
              <b-form-input
                v-model="title"
                placeholder="عنوان درخواست  را وارد کنید"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>
                تاریخ جریان
              </label>
              <date-picker
                v-model="processDate"
                type="date"
                display-format="jDD jMMMM jYYYY"
                format="YYYY-MM-DD"
                clearable
              />

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group
              label="شرکت"
            >
              <b-overlay
                :show="companyList.length === 0"
              >
                <v-select
                  v-model="company"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="companyList"
                  :reduce="company => company.id"
                />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="روند"
            >
              <b-overlay :show="!processProgress">
                <v-select
                  v-model="mainProcess"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="processes"
                  :reduce="process => process.id"
                />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col
            v-if="childProcess.length > 0"
            md="4"
          >
            <b-form-group
              label="موضوع روند"
            >
              <v-select
                v-model="processId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="childProcess"
                :reduce="process => process.id"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-for="(field,index) in fields"
            :key="index"
            cols="12"
          >
            <b-form-group
              class="col-md-4"
              :label="field.title"
              :description="field.help"
            >
              <b-form-input
                v-model="field.value"
                :placeholder="`${field.title} را وارد کنید`"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="this.processDescription"
          class="mt-2"
        >
          <b-col cols="12">
            <b-card
              style="border: 1px solid #e3e2e2"
              title="توضیحات ثبت درخواست:"
            >
              <b-card-text v-html="this.processDescription" />
            </b-card>

          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="متن درخواست"
            >
              <div>
                <quill-editor
                  v-model="content"
                  :options="editorOption"
                />
              </div>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-card-body>
                <b-row
                  v-for="(item, index) in attachment.items"
                  :id="item.id"
                  :key="item.id"
                >
                  <!-- Item Name -->
                  <b-col md="4">
                    <b-form-group>
                      <label :for="`attachment_${item.id}`">
                        <feather-icon
                          icon="PaperclipIcon"
                        />
                        فایل
                      </label>
                      <b-form-file
                        v-model="item.file"
                        placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                        drop-placeholder="عکس را به اینحا بکشید"
                        no-drop
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                    lg="2"
                    md="3"
                    class="mb-50"
                  >
                    <b-button
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      @click="removeItem(index)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-25"
                      />
                      <span>حذف فایل</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-button
                  variant="primary"
                  @click="repeateAgain"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                  />
                  <span>افزودن فایل</span>
                </b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-button
          variant="success"
          :disabled="onProgress"
          @click="createRequest"
        >
          <b-spinner
            v-if="onProgress"
            small
          />
          {{ onProgress ? 'درحال پردازش درخواست...' : 'ثبت درخواست ' }}
        </b-button>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BFormFile,
  BFormTextarea,
  BCardText,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import { doubleRaf } from '@/libs/utils'

export default {
  name: 'RequestsCreate',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    BFormFile,
    quillEditor,
    BFormTextarea,
    BCardText,

  },
  data() {
    return {
      title: '',
      getFieldProgress: false,
      onProgress: false,
      content: '',
      editorOption: {
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
      },
      sms: '',
      maxChar: 140,
      company: '',
      companyList: [],
      attachment: {
        items: [
          {
            id: 1,
            file: null,
          },
        ],
        nextItemId: 2,
      },
      fields: [],
      processes: [],
      processProgress: false,
      mainProcess: null,
      processId: null,
      childProcess: [],
      processDescription: '',
      processDate: '',
    }
  },
  watch: {
    mainProcess(newValue, oldValue) {
      if (newValue !== null) {
        const process = this.processes.find(process => process.id === newValue)
        if (process) {
          this.childProcess = process.children

          if (process.children.length > 0) {
            if (process.children.length > 1) {
              this.childProcess = process.children
            }
            doubleRaf(() => {
              this.processId = process.children[0].id
            })
          }
        } else this.childProcess = []
      } else this.childProcess = []

      this.processId = null
    },
    processId(newValue, oldValue) {
      if (newValue !== null) {
        this.getFields()
        const process = this.childProcess.find(process => process.id === newValue)
        this.processDescription = process.description
      }
    },
  },
  mounted() {
    this.getCompanies()
    this.getProcesses()
  },

  methods: {
    repeateAgain() {
      this.attachment.nextItemId++
      this.attachment.items.push({
        id: this.attachment.nextItemId,
        file: null,
      })
    },
    removeItem(index) {
      this.attachment.items.splice(index, 1)
    },
    getProcesses() {
      this.$http.get('processes/related')
        .then(({ data }) => {
          this.processes = data
          this.processProgress = true
        })
        .catch(({ error }) => {
          this.$bvToast.toast(error.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
    getFields() {
      this.$http.get(`processes/${this.processId}/fields`)
        .then(({ data }) => {
          this.fields = data
          this.getFieldProgress = true
        })
        .catch(({ error }) => {
          this.$bvToast.toast(error.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
    getCompanies() {
      this.$http.get('companies')
        .then(({ data }) => {
          this.companyList = data
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
    async createRequest() {
      if (this.title === '') {
        this.$bvToast.toast('عنوان درخواست نمیتواند خالی باشد', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }
      if (this.content == null) {
        this.$bvToast.toast('متن درخواست وارد شود', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }

      this.onProgress = true
      this.onSaving = true

      const requestFormData = new FormData()

      requestFormData.append('title', this.title)
      requestFormData.append('content', this.content)
      requestFormData.append('company', this.company)
      requestFormData.append('process_id', this.processId)
      requestFormData.append('process_at', this.processDate)
      this.attachment.items.map(attachment => {
        requestFormData.append('attachments[]', attachment.file)
      })
      this.fields.map((field, index) => {
        requestFormData.append(`fields[${index}][id]`, field.id)
        requestFormData.append(`fields[${index}][value]`, field.value)
      })

      await this.$http.post('requests', requestFormData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
        .then(({ data }) => {
          if (data.status) {
            this.title = ''
            this.content = ''
            this.processId = null
            this.attachment = {
              items: [
                {
                  id: 1,
                  file: null,
                },
              ],
              nextItemId: 2,
            }

            this.$bvToast.toast('درخواست  با موفقیت ثبت شد', {
              title: 'انجام درخواست',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'success',
            })
          } else {
            this.$bvToast.toast(data.message ?? 'ثبت درخواست  انجام نشد', {
              title: 'حطا',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
  },
}
</script>
